export default __webpack_public_path__ + "static/media/numpy-simple.b007f96a.svg";